export function initialiseSegment (key) {
  if (window.analytics) {
    window.analytics.load(key, {
      integrations: {
        'Segment.io': {
          apiHost: 'av1-ev.onlinedoctor.asda.com/v1'
        }
      }
    })
  }
}

export function addHotjarMiddleWare () {
  window.analytics.ready(() => {
    window.analytics.addDestinationMiddleware('Hotjar', [ hotjarMiddleWare ])
  })
}

export function hotjarMiddleWare ({ payload, integration, next }) {
  payload.obj.source = 'porta'

  // Remove PII data from the payload sent to Hotjar
  delete payload.obj.traits.email
  delete payload.obj.traits.firstName
  delete payload.obj.traits.gender
  delete payload.obj.traits.lastName

  next(payload)
}
